import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { useData } from '../../context/DataContext';
import Calendar from '../../components/Calendar';
import './Calendar.css';

const StudentCalendar = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { getStudentEnrollments, data } = useData();

  const userId = user?.id || user?._id;
  const enrollments = getStudentEnrollments(userId);
  const enrolledCourseIds = new Set(enrollments.map(e => String(e.courseId || e.course?.id)));

  const events = (data.schedules || [])
    .filter(event => enrolledCourseIds.has(String(event.courseId)))
    .map(event => ({
      ...event,
      title: event.courseCode ? `${event.courseCode} - ${event.title}` : event.title,
      extendedProps: {
        courseName: event.courseName,
        courseCode: event.courseCode,
        location: event.location
      }
    }));

  const handleEventClick = (info) => {
    const start = new Date(info.event.start);
    const end = info.event.end ? new Date(info.event.end) : null;
    const location = info.event.extendedProps?.location || '-';
    const message = [
      `${t('course.title')}: ${info.event.title}`,
      `${t('course.location')}: ${location}`,
      `${t('exam.date')}: ${start.toLocaleDateString()}`,
      `${t('exam.duration')}: ${start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}${end ? ` - ${end.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}` : ''}`
    ].join('\n');
    alert(message);
  };

  return (
    <div className="student-calendar-page">
      <div className="page-header">
        <h1>{t('student.myCalendar')}</h1>
      </div>

      <Calendar 
        events={events}
        onEventClick={handleEventClick}
        editable={false}
      />
    </div>
  );
};

export default StudentCalendar;
